import { useEffect } from "react";
import { trackEvent } from "@/lib/leadTracking";

/**
 * Global CTA click tracker.
 * Captures clicks on any element with `data-cta-type` (already used across the site)
 * and logs them to the `lead_events` table so we never miss an interaction.
 */
const CTATracker = () => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const el = target.closest<HTMLElement>("[data-cta-type]");
      if (!el) return;
      const ctaType = el.dataset.ctaType;
      const ctaLocation = el.dataset.ctaLocation;
      if (!ctaType) return;
      trackEvent(`cta_${ctaType}`, ctaLocation, {
        href: (el as HTMLAnchorElement).href ?? null,
        text: el.textContent?.trim().slice(0, 80) ?? null,
      });
    };
    document.addEventListener("click", handler, { capture: true });
    return () => document.removeEventListener("click", handler, { capture: true });
  }, []);
  return null;
};

export default CTATracker;
